import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'extend',
})
export class ExtendPipe implements PipeTransform {

    transform<T extends object, S extends object>(value: T, extendWith: S): T & S {
        return {
            ...value,
            ...extendWith,
        }
    }

}
